export default (function () {
    document.querySelectorAll('[data-module="entry-read-more"]').forEach((button) => {
        button.addEventListener('click', () => {
            button.classList.add('open')
            button.style.display = 'none'
        })
    })
})
